import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Dropdown, DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const renderListItems = ({
  hasFormsWriteAccess,
  onCreateClick,
  onCloneClick,
  onPagesClick,
  onEditorClick,
  onViewSubmissionsClick,
  guid
}) => /*#__PURE__*/_jsxs(List, {
  wrapChildren: true,
  children: [/*#__PURE__*/_jsx(Button, {
    "data-selenium": "form-actions-dropdown-view-submissions",
    disabled: !hasFormsWriteAccess,
    onClick: () => onViewSubmissionsClick(guid),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('viewSubmissions')
    })
  }), /*#__PURE__*/_jsx(Button, {
    "data-selenium": "form-actions-dropdown-form-clone",
    disabled: !hasFormsWriteAccess,
    onClick: () => onCloneClick(guid),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('clone')
    })
  }), /*#__PURE__*/_jsx(Button, {
    "data-selenium": "form-actions-dropdown-view-pages",
    disabled: !hasFormsWriteAccess,
    onClick: onPagesClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('pages')
    })
  }), /*#__PURE__*/_jsx(Button, {
    "data-selenium": "form-actions-dropdown-go-to-editor",
    disabled: !hasFormsWriteAccess,
    onClick: onEditorClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('editor')
    })
  }), /*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsx(Button, {
    "data-selenium": "form-actions-dropdown-form-create",
    disabled: !hasFormsWriteAccess,
    onClick: onCreateClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('create')
    })
  })]
});
const FormActionsDropdown = props => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  justify: "between",
  gap: 10,
  marginBlockEnd: "400",
  children: [/*#__PURE__*/_jsx(Box, {
    grow: 1,
    children: /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "600",
      as: "div",
      children: /*#__PURE__*/_jsx(Dropdown, {
        "data-selenium": "form-actions-dropdown",
        buttonSize: "small",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('actions')
        }),
        children: renderListItems(props)
      })
    })
  }), /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('rawHTMLWarning.description')
      })
    })
  })]
});
export default FormActionsDropdown;